<template>
  <span v-show="verificar(attribute_name)!=''" class="required text-danger">
    {{ errors_form['items'].length>0 ? verificar(attribute_name):"" }}</span>
</template>
<script>
  export default {
    name: "ErrorComponent",
    props: ['attribute_name', 'errors_form'],
    data: function () {
      return {
        errores: this.errors_form
      }
    },
    methods: {
      verificar(attribute_name) {
           let resultado=this.errors_form['items'].find(element => element.field == attribute_name);
          if(resultado!=undefined){
            return "(*) "+ resultado['msg'];
          }else{
            return "";
          }
        
      }
    }
  }
</script>
